<template>
  <div class="images_block">
    <template v-if="files.length">
      <div v-for="(f, id) in images" :key="id">
        <div class="images_block_item">
          <ImageFullModal
            maxHeight="170"
            minHeight="80"
            minWidth="80"
            :max-img="apiDomain + '/' + f"
            :min-img="apiDomain + '/min/' + f"
            :items="images"
            :item-active="id"
            :type="f.url ? 'scheme' : null"
          >
            <template v-if="edit && !disabled" slot="button">
              <ImageEdit :src="f.url ? f.url : f" :id="id" :on-edit="editImage" get-upload/>
            </template>
          </ImageFullModal>
          <div class="z-index d-flex justify-space-between mt-n3">
            <BaseTooltip :tooltip="localStorage.translations.pages.common.buttons['udalit']">
              <BaseButton
                round
                icon_only
                default_icon="button-delete"
                size="30"
                padding="7"
                background-color="#eb5757"
                @click="askDeleteImage(id)"
                class="ma-n3"
                :disabled="disabled"
              />
              <v-dialog v-model="dialog" width="400">
                <v-card class="pa-4">
                  <v-btn icon absolute right top class="mt-n2 mr-n2" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <h3 class="text-center">{{ localStorage.translations.pages.common.buttons['udalit'] }} ?</h3>
                  <div class="d-flex justify-space-around mt-8">
                    <v-hover v-slot="{ hover }">
                      <v-btn fab :outlined="!hover" :depressed="!hover" dark color="#26bc2c" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-hover>
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        fab :depressed="!hover" :outlined="!hover" :dark="hover"
                        color="red"
                        @click="onDeleteImage(id)"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </v-hover>
                  </div>
                </v-card>
              </v-dialog>
            </BaseTooltip>
            <BaseTooltip :tooltip="localStorage.translations.pages.common.buttons['redaktirovat']">
              <BaseButton
                round
                icon_only
                default_icon="button-edit"
                size="30"
                padding="7"
                @click="onEditImage(id)"
                class="ma-n3"
                :disabled="disabled"
              />
              <ImageEdit
                :src="f.url ? f.url : f"
                :id="id"
                :on-edit="editImage"
                get-upload
                :ref="'edit_image_' + id"
                invisible
              />
            </BaseTooltip>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ImageFullModal from "components/ImageFullModal";
import ImageEdit from "components/ImageEdit";
import {mapGetters} from "vuex";
export default {
  name: "TimeControlShowEmployeeDayGalleryV2",
  components: {ImageEdit, ImageFullModal},
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onChange: {},
    externalData: {
      type: [Boolean, Number, String, Object, Array],
      default: null,
    },
  },
  data: () => ({
    dialog: false,
    id: 0,
  }),
  computed: {
    ...mapGetters(['apiDomain']),
    images() {
      if (this.files.length) {
        if (this.files[0].url)
          return this.files.map(i => i.url)
      }
      return this.files
    },
  },
  methods: {
    editImage(image, id) {
      let temp = [].concat(this.files)
      this.externalData.onDelete = temp[id].url ? temp[id].url : this.files[id]
      if (temp[id].url) {
        temp[id].url = image
      } else {
        temp[id] = image
      }
      if (this.onChange) this.onChange(temp, this.externalData)
    },
    askDeleteImage(id) {
      this.id = id
      this.dialog = true
    },
    onDeleteImage() {
      this.externalData.onDelete = this.files[this.id]
      let temp = [].concat(this.files)
      temp.splice(this.id, 1)
      if (this.onChange) this.onChange(temp, this.externalData)
      this.dialog = false
    },
    onEditImage(id) {
      if (this.$refs['edit_image_' + id]) {
        this.$refs['edit_image_' + id][0].openCropDialog()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.images_block {
  display: grid;
  grid-template-columns: repeat(auto-fill, 170px);
  gap: 50px;
  width: 100%;
  //min-width: 280px;

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(auto-fill, 100px);
  }

  &_item {
    display: grid;
    .v-image {
      position: relative;
    }
    .z-index {
      z-index: 2;
    }
  }
}

.d-flex {
  width: 100%;
}
</style>